export default "__VITE_ASSET__BsP4_4Xy__"